export default __webpack_public_path__ + "static/media/arrow.2d2cca04.png";